const JuiceReducer = (state = { juice: 0 }, action) => {
  switch (action.type) {
    case "Juice":
      return { ...state, juice: action.payload };
    default:
      return state;
  }
};
export default JuiceReducer;
